"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _Panel = _interopRequireDefault(require("../Panel/Panel"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Button = _interopRequireDefault(require("../Button"));

var _DialogModule = _interopRequireDefault(require("./Dialog.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref3 =
/*#__PURE__*/
_react.default.createElement(_Icon.default, {
  type: "close-medium"
});

/**
 * "Dialog" is based on the "Modal" component and inherits all of its possible props
 */
var Dialog = function Dialog(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      children = _ref.children,
      autoFocus = _ref.autoFocus,
      showCloseBtn = _ref.showCloseBtn,
      withHeader = _ref.withHeader,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["classes", "title", "children", "autoFocus", "showCloseBtn", "withHeader", "size"]);

  var _ref2 =
  /*#__PURE__*/
  _react.default.createElement("span", null, title);

  return _react.default.createElement(_Modal.default, _extends({
    as: _Panel.default
  }, props, {
    classes: {
      wrapper: _DialogModule.default.wrapper,
      modal: (0, _classnames.default)(_DialogModule.default.modal, size === 's' && _DialogModule.default.modal__s, size === 'm' && _DialogModule.default.modal__m, classes.dialog, !autoFocus && _DialogModule.default.animation)
    }
  }), function (closeModal) {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Panel.default.Title, {
      withPadding: true,
      className: (0, _classnames.default)(_DialogModule.default.title, !title && _DialogModule.default.title__emptyTitle, classes.title)
    }, _ref2, showCloseBtn && _react.default.createElement("div", {
      onClick: closeModal,
      className: _DialogModule.default.close
    }, _ref3)), children);
  });
};

Dialog.ScrollContent = function (_ref4) {
  var className = _ref4.className,
      props = _objectWithoutProperties(_ref4, ["className"]);

  return _react.default.createElement(_Panel.default.Content, _extends({
    className: (0, _classnames.default)(_DialogModule.default.content, className)
  }, props));
};

Dialog.Actions = function (_ref5) {
  var className = _ref5.className,
      props = _objectWithoutProperties(_ref5, ["className"]);

  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)(_DialogModule.default.actions, className)
  }, props));
};

Dialog.Cancel = function (_ref6) {
  var className = _ref6.className,
      props = _objectWithoutProperties(_ref6, ["className"]);

  return _react.default.createElement(_Button.default, _extends({
    border: true,
    className: (0, _classnames.default)(_DialogModule.default.cancel, className)
  }, props));
};

Dialog.Approve = function (_ref7) {
  var className = _ref7.className,
      disabled = _ref7.disabled,
      isLoading = _ref7.isLoading,
      props = _objectWithoutProperties(_ref7, ["className", "disabled", "isLoading"]);

  return _react.default.createElement(_Button.default, _extends({
    variant: "fill",
    accent: "positive",
    disabled: disabled,
    isLoading: isLoading,
    className: (0, _classnames.default)(_DialogModule.default.approve, className, disabled && _DialogModule.default.disabled, isLoading && _DialogModule.default.loading)
  }, props));
};

Dialog.defaultProps = {
  showCloseBtn: true,
  withHeader: true,
  withAnimation: true,
  size: null,
  classes: {
    dialog: '',
    title: ''
  }
};
var _default = Dialog;
exports.default = _default;